<template>
<div id="consulta_bitacora_archivosm">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container grid-list-md text-xs-center>

        <v-flex xs12>
            <base-material-card color="primary" icon="library_books" title="Bitácora de Archivos M" class="elevation-1 px-5 py-3">
                <br />

                        <v-card-text>
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn fab dark x-small color="secondary" to='/mv_cargazip' title="Carga .zip Archivo M"
                                  v-tippy>
                                <v-icon>mdi-upload</v-icon>
                                </v-btn>


                              </v-card-actions>


                         <v-tabs grow style="margin-bottom: 30px">
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab :key="'in-pendiente'">Pendientes</v-tab>
                        <v-tab :key="'in-creado'">Generados</v-tab>
                        <v-tab-item :key="'in-pendiente'">
                                 <v-form ref="formreporte" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-switch
                                            v-model="fecha_factura"
                                            color="red darken-3"
                                            label="Fecha de Pedimento"
                                        ></v-switch>
                                          </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-btn rounded color="secondary" @click="cargar()" :loading="loadingReporte">
                                                <v-icon>search</v-icon>Consultar
                                            </v-btn>
                                          </v-col>
                                    </v-row>
                                      <v-chip
                            class="ma-2"
                        color="secondary"
                        outlined
                        >
                        <v-icon left>
                            mdi-information
                        </v-icon>
                         Consulta por rango de fechas, haciendo referencia a la fecha de proceso en que se carga el archivo ".zip" o por fecha de pedimento localizada en el archivo M

                        </v-chip>



                                </v-container>
                            </v-form>
                             <v-card-actions>

                                    <v-btn v-if="datafiltered.length>0" small dark color="success" @click="enviarTodos()" >
                                                <v-icon >mdi-file-plus</v-icon> Crear Seleccionados
                                     </v-btn> &nbsp;&nbsp;
                                     <v-btn  v-if="selecteds.length>0" small color="red" @click.native="eliminarTodos( '¿Está seguro que desea ELIMINAR todos los registros seleccionados?')" title="Eliminar Seleccionados" v-tippy>
                                        <v-icon small >mdi-delete-clock</v-icon> Eliminar Seleccionados</v-btn>
                                    <v-spacer></v-spacer>
                                    <exportar-excel :data="datos" :exportFields="data_resumen_excel" name="Bitacora_Archivos_M_Pendientes.xlsx">
                                        <v-btn icon small dark  color="success" title="Exportar Bitácora" v-tippy>
                                            <v-icon  dark>mdi-table</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </v-card-actions>

                                    <v-client-table id="vuetable" ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-5 ma-5" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>

                                        <div slot="filter__id" >
                                            <input type="checkbox" class="form-control check-all" v-model='allChecked' @change="check_all()"  >
                                        </div>
                                        <template slot="id" slot-scope="props" >
                                            <div style="display:flex; justify-content:center;" >
                                            <input :id="props.row.id" type="checkbox" v-model="selecteds" :value="props.row.id" @change="acomoda_selecteds();" :disabled = "allChecked" />
                                            </div>
                                        </template>

                                         <template slot="nombre_zip" slot-scope="props" >
                                            {{props.row.nombre_zip.toUpperCase().indexOf(".ZIP")!=-1 ? props.row.nombre_zip.substring(8, props.row.nombre_zip.length) : props.row.nombre_zip}}
                                        </template>
                                        <!-- YA NO SE ACTUALIZARÁ EL PROVEEDOR MANUALMENTE, SE ACTUALIZARAN CON LOS COVES RECUPERADOS ASOCIADOS A LA MANIFESTACIÓN YA LA BITACORA NO IMPORTA EL PROVEEDOR -->
                                        <!--template slot="proveedor" slot-scope="props" >
                                            <div class="text-center">
                                                <v-btn x-small v-if="props.row.proveedor==null" text  color="secondary" title="Actualizar Proveedor"  @click="model.id = props.row.id; model.proveedor = props.row.proveedor; modal= true;" v-tippy>
                                                    <v-icon dark>mdi-square-edit-outline</v-icon>
                                                </v-btn>
                                                <a  @click="model.id = props.row.id; model.proveedor = props.row.proveedor; modal= true;" v-tippy title="Actualizar Proveedor">{{props.row.proveedor}}</a>
                                            </div>
                                        </template-->
                                        <template slot="actions" slot-scope="props" >
                                           <v-btn x-small text icon color="primary" title="Proforma ArchivoM"
                                                v-show="(props.row.key_pdf!=null && props.row.key_pdf!='')"
                                                @click="download_pdf(props.row.key_pdf)" v-tippy>
                                                <v-icon dark>picture_as_pdf</v-icon>
                                            </v-btn>
                                            <v-btn x-small text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" v-tippy>
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                             <!--v-btn x-small text icon color="primary" title="Descargar Archivo ZIP"  @click="download(props.row.nombre_zip)" v-tippy>
                                                <v-icon dark>get_app</v-icon>
                                            </v-btn-->
                                              <v-btn x-small  text icon color="secondary" title="Consultar Adjuntos"  @click="lista = props.row; modal_docs=true;" v-tippy>
                                                <v-icon dark>mdi-folder-search</v-icon>
                                            </v-btn>
                                              <v-btn x-small v-if="props.row.estatus=='PENDIENTE'" text icon color="success" title="Crear Solicitud de MVe"  @click="generarMV(props.row)" v-tippy>
                                                <v-icon dark>mdi-file-plus</v-icon>
                                            </v-btn>
                                               <v-btn x-small v-if="props.row.estatus=='DUPLICADO'" text icon color="purple" title="Remplazar Manifestación de Valor"  @click="remplazarMV(props.row)" v-tippy>
                                                <v-icon >mdi-file-replace</v-icon>
                                            </v-btn>

                                        </template>
                                    </v-client-table>
                        </v-tab-item>
                         <v-tab-item :key="'in-creado'">
                                 <v-form ref="formreporte" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu3 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu3 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu4 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu4 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-switch
                                            v-model="fecha_factura"
                                            color="red darken-3"
                                            label="Fecha de Pedimento"
                                        ></v-switch>
                                          </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-btn rounded color="secondary" @click="cargarCreados()" :loading="loadingReporte">
                                                <v-icon>search</v-icon>Consultar
                                            </v-btn>
                                          </v-col>
                                    </v-row>

                                </v-container>
                            </v-form>
                                    <v-client-table id="vuetable2"  ref="vuetable2" :data="datos2" :columns="columns" :options="options" class="elevation-2 pa-5 ma-5" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>
                                         <template slot="nombre_zip" slot-scope="props" >
                                            {{props.row.nombre_zip.toUpperCase().indexOf(".ZIP")!=-1 ? props.row.nombre_zip.substring(8, props.row.nombre_zip.length) : props.row.nombre_zip}}
                                        </template>

                                        <template slot="actions" slot-scope="props" >
                                            <v-btn x-small text icon color="primary" title="Proforma ArchivoM"
                                                v-show="(props.row.key_pdf!=null && props.row.key_pdf!='')"
                                                @click="download_pdf(props.row.key_pdf)" v-tippy>
                                                <v-icon dark>picture_as_pdf</v-icon>
                                            </v-btn>
                                            <!--v-btn x-small icon text color="primary" title="Descargar Archivo ZIP"  @click="download(props.row.nombre_zip)" >
                                                <v-icon dark>get_app</v-icon>
                                            </v-btn-->

                                        </template>
                                    </v-client-table>

                        </v-tab-item>
                         </v-tabs>
                        </v-card-text>


            </base-material-card>
        </v-flex>

    </v-container>
     <v-dialog v-model="modal" max-width="55%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>&nbsp;
                                    <span class="subheading" >
                                        <strong>Actualizar Proveedor</strong>
                                    </span>
                                </v-card>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md text-xs-center>
                                    <v-form ref="formgenerar" lazy-validation>
                                        <v-card-text>
                                            <v-container grid-list-md text-xs-center>
                                                <v-row>
                                                    <v-col>
                                                        <v-autocomplete :hide-no-data="true" :items="emisores" v-model="model.proveedor"
                                                        :item-text="getNombreEmisor" item-value="rfc" label="Seleccione Emisor/Destinatario" ></v-autocomplete>
                                                    </v-col>
                                                </v-row>

                                            </v-container>
                                        </v-card-text>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="success" @click="actualiza_proveedor" >
                                    <v-icon>done</v-icon>Actualizar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="modal_docs" max-width="500px" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon @click.native="modal_docs = false" class="white--text" >cancel</v-icon>&nbsp;
                                    <span class="subheading" >
                                        <strong>Documentos</strong>
                                    </span>
                                </v-card>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md text-xs-center>
                                    <v-form ref="formgenerar" lazy-validation>
                                        <v-card-text>
                                            <v-container grid-list-md text-xs-center>

                                              <h5>COVES</h5>

                                               <ol id="example-1">
                                                <li v-for="item in lista.coves">
                                                    {{ item }}
                                                </li>
                                                </ol>


                                              <h5>EDOCUMENTS</h5>


                                              <ol id="example-1">
                                                <li v-for="item in lista.eDocuments">
                                                    {{ item }}
                                                </li>
                                                </ol>

                                            </v-container>
                                        </v-card-text>
                                    </v-form>
                                </v-container>
                            </v-card-text>

                        </v-card>
                    </v-dialog>
</div>

</template>

<script>
import axios from "axios";

import moment from "moment";


export default {
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
               return this.$refs.vuetable.allFilteredData;
            } else {
               return this.datos;
            }

        },
        datafiltered2() {
            let self = this;
            let result = [];
            self.selecteds = [];
            self.selecteds_acomodados= [];
            if (this.$refs.vuetable != null) {
                result = this.$refs.vuetable.allFilteredData;
                    if( self.allChecked ){
                        let arr = self.allChecked ? result.map(row =>  row.id) : [];

                        if (arr.length > 0) {
                            for (var i = 0; i < arr.length; i++) {
                            if (self.selecteds.includes(arr[i])) {
                                continue;
                            } else {
                                self.selecteds.push(arr[i]);
                            }
                            }
                        }
                        self.acomoda_selecteds();

                    }

                return result;
            } else {
                result = this.datos;
                if( self.allChecked ){
                        let arr = self.allChecked ? result.map(row =>  row.id) : [];

                        if (arr.length > 0) {
                            for (var i = 0; i < arr.length; i++) {
                            if (self.selecteds.includes(arr[i])) {
                                continue;
                            } else {
                                self.selecteds.push(arr[i]);
                            }
                            }
                        }
                        self.acomoda_selecteds();
                    }
                return result;
            }
        },

    },

    created: function () {
        this.URL = this.$hostname ;
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        this.cliente = this.$local_storage.get("id_cliente");

        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
            this.permisoEliminar = true;

        this.cargarEmisores();
        this.getPatentes();


        var f = new Date();
         var f_de = new Date();

              f_de.setDate(f_de.getDate() + 1);



                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d_de < 10)
                    d_de = '0' + d_de;

                let y = f.getFullYear();
                let m = f.getMonth() + 1;
                let d = f.getDate();


                if (m < 10)
                    m = '0' + m;
                if (d < 10)
                    d = '0' + d;


                this.model.fecha_de = y + "-" + m + "-" + d;
                this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;
    },
    filters: {
        uppercase: function(value) {
            if (!value) return ''
            value = value.toString()
            return value.toUpperCase()
        },
    },
    data: () => ({
        modal_docs: false,
        permisoEliminar: false,
        tab: null,
        cliente: 0,
        emisores: [],
        lista: {
            'coves':[],
            'eDocuments':[]
        },
        data_table_impo: [],
        lista_filtrada: [],
        modal: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "EManifiesto",
                disabled: true,
                to: ""
            },
            {
                text: "Bitácora M",
                disabled: true,
                to: "",
            },
        ],

        patentes: [],
        datos: [],
        datos2: [],
        selecteds: [],
        selecteds_acomodados:[],
        allChecked: false,
        columns: [
            "id",
            "fecha",
            "iniciales",
            "origen",
            "nombre_zip",
            "cantidad_archivos",
            "numero_archivo",
            "no_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "proveedor",
            "error_pdf",
            "estatus",
            "actions",
        ],
        options: {
            filterable: [
            "fecha",
            "iniciales",
            "origen",
            "nombre_zip",
            "cantidad_archivos",
            "numero_archivo",
            "no_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "proveedor","error_pdf",
            "estatus",
            ],
            sortable: [
            "fecha",
            "iniciales",
            "origen",
            "nombre_zip",
            "cantidad_archivos",
            "numero_archivo",
            "no_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "proveedor","error_pdf",
            "estatus",
            ],

            headings: {
                'id':'',
                 "fecha":"Fecha",
                "iniciales":"Usuario",
                "origen":"Origen",
                "nombre_zip":"Archivo Cargado",
                "cantidad_archivos":"Cantidad",
                "numero_archivo":"Archivo M",
                "no_pedimento":"Número de Pedimento",
                "fecha_pedimento": "Fecha Pedimento",
                "clave_pedimento":"Clave de Documento",
                "proveedor": "Proveedores",
                "error_pdf":"Error al generar Proforma",
                "estatus": "Estatus",
                actions: "Acciones",
            },
        },
        data_resumen_excel: {
               "Fecha": "fecha",
               "Usuario":"iniciales",
               "Origen":"origen",
               "Archivo Cargado":"nombre_zip",
               "Cantidad": "cantidad_archivos",
               "Archivo M":"numero_archivo",
               "Número de Pedimento": "no_pedimento",
               "Fecha Pedimento":"fecha_pedimento",
               "Clave de Documento": "clave_pedimento",
                "Proveedor":"proveedor",
                "Estatus": "estatus",
            },
        loading: true,
        loadingReporte: false,
        show_loading: true,
        model: {
            rfc: "",
            usuario: "",
            fecha_de: "",
            fecha_a: "",
            nombre: "",
            id_manifestacion: "",
            proveedor: "",
            archivos: [],
        },
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        fecha_factura: false,

        tiposDocumentos: [],
        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },

        modal: false,

    }),

  //  0-Creado, 1-Manifestacion Creada, 2-Duplicado, 3-Error al leer archivoM, 4-Error al crear la manifestación, 5-Manifestacion transmitida
    methods: {
        acomoda_selecteds(){
            let self = this;
            self.selecteds_acomodados = [];
            self.selecteds.forEach(function(x){
                if( Array.isArray(x)){
                    self.selecteds_acomodados = self.selecteds_acomodados.concat(x);
                }else{
                    self.selecteds_acomodados.push(x);
                }
            });
        },
        check_all: function() {
            let arr = this.allChecked ? this.datafiltered2.map(row =>  row.id) : [];

            if (arr.length == 0) {
                this.selecteds = [];
            } else {
                for (var i = 0; i < arr.length; i++) {
                    if (this.selecteds.includes(arr[i])) {
                        continue;
                    } else {
                        this.selecteds.push(arr[i]);
                    }
                }
            }
            this.acomoda_selecteds();
        },

        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            let fecha = 0;
            if (this.fecha_factura )
                fecha = 1;

            let data = {
                rfc: this.model.rfc,
                estatus: [0,2,3,4],
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a,
                fecha_pedimento : fecha
            };
            axios.post(this.URL + "bandeja_temporal/get_bitacora_manifestacion/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_pedimento = this.parseDate(this.datos[k].fecha_pedimento);
                            this.datos[k].fecha = this.parseDate(this.datos[k].fecha);
                            var proveedores = [];
                            for(var kpro in this.datos[k].proveedor){
                                 proveedores.push(this.datos[k].proveedor[kpro]["rfc"]);
                            }
                            this.datos[k].proveedor = proveedores.join(", ");
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los registros",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        cargarEmisores: function () {
            var datos = {
                cliente: this.cliente
            };
            axios
                .post(this.$hostname + "catalogos/emisores_destinatarios/get_emisores/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.emisores = res.data;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los emisores.",
                        footer: ""
                    });
                });
        },
        getNombreEmisor:function(record){
            return record.rfc+" - "+record.razon_social;
        },
        actualiza_proveedor:function(){
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: this.model.id,
                        proveedor: this.model.proveedor
                    };
                    axios
                        .post(this.$hostname + "bandeja_temporal/update_bitacora_manifestacion/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El proveedor se actualizo con exito",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al actualizar el proveedor. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                            this.cargar();
                        });
        },
        cargarCreados: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
              let fecha = 0;
            if (this.fecha_factura )
                fecha = 1;

            let data = {
                rfc: this.model.rfc,
                estatus: [1, 5],
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a,
                fecha_pedimento: fecha
            };
            axios.post(this.URL + "bandeja_temporal/get_bitacora_manifestacion/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos2 = res.data;
                        this.datos2.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha) ;
                        });
                        for (var k in this.datos2) {
                            this.datos2[k].fecha_pedimento = this.parseDate(this.datos2[k].fecha_pedimento);
                            this.datos2[k].fecha = this.parseDate(this.datos2[k].fecha);
                            this.datos2[k].estatus = this.getEstatus(this.datos2[k].estatus);
                            var proveedores = [];
                            for(var kpro in this.datos2[k].proveedor){
                                 proveedores.push(this.datos2[k].proveedor[kpro]["rfc"]);
                            }
                            this.datos2[k].proveedor = proveedores.join(", ");
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getPatentes: function () {
            let self = this;
            var data = {
                cliente: this.$local_storage.get("rfc"),
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            };
            axios
                .post(
                    this.$hostname + "catalogos/certificados/list_certificados_agentes/",
                    data
                )
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.patentes = res.data;

                    }
                })
                .catch(err => {

                    console.log(err);
                });
        },
        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return ""
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },
        enviarTodos: function(){
            let self = this;
              this.$swal({
                type: "info",
                title: "Se enviarán los registros seleccionados ¿Desea Continuar?",
                text: "" ,
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {

                    if(self.selecteds_acomodados.length>0){
                        var tienen_proveedor = [];
                        if (self.$refs.vuetable != null) {
                            tienen_proveedor = self.$refs.vuetable.allFilteredData.filter(r => self.selecteds_acomodados.includes(r.id) );
                        } else {
                            tienen_proveedor = self.datos.filter(r => self.selecteds_acomodados.includes(r.id));
                        }

                        if(tienen_proveedor.length > 0){
                            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                            tienen_proveedor.forEach(async function(r){
                                if(r.estatus=="PENDIENTE"){
                                    await self.generarMVMasivo(r);
                                }
                            });
                            self.$swal({
                                type: "success",
                                title: "¡Operación Realizada!",
                                text: "Se enviaron crear los registros seleccionados.",
                                footer: "",
                            }).then((result) => {
                                if (result.value) {
                                    self.cargar();
                                }
                            });
                        } else {
                            self.$swal({
                                type: "info",
                                title: "¡Operación NO Realizada!",
                                text: "De los registros seleccionados, ninguno cuenta con proveedor asignado.",
                                footer: "Favor de Verificar.",
                            })
                        }



                    }

                }
            });
        },

        eliminarTodos:function (msg) {
           let self = this;
           var rfc = this.$local_storage.get("rfc");

           let msg2 = "¿Está seguro que desea ELIMINAR " + self.selecteds.length + " registros seleccionados?";
           if(self.selecteds_acomodados.length == 1)
             msg2 = "¿Está seguro que desea ELIMINAR " + self.selecteds.length + " registro seleccionado?";


           self.$swal({
                type: "info",
                title: "Cuidado",
                text: msg2,
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(async result => {
                if (result.value) {
                    self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                    //console.log("Acomodados: ",self.selecteds_acomodados);
                    await Promise.all(self.selecteds_acomodados.map(async (x) => {
                        var datos = {
                            id: x,
                        };
                        await axios
                            .post(self.$hostname + "bandeja_temporal/delete_bitacora_manifestacion/", datos)
                            .then((res) => {
                            })
                            .catch((error) => {
                                console.log(error);
                            });

                    }));
                    self.$root.$dialogLoader.hide();
                    self.$swal({
                            type: "success",
                            title: "¡Operación Realizada!",
                            text: "Se eliminaron los registros seleccionados.",
                            footer: "",
                    }).then((result) => {
                        self.cargar();
                    });
                  }
            });


        },

        validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },

        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },



        getEstatus: function (estatus) {
            var arr_estatus  = ["PENDIENTE", "GENERADO", "DUPLICADO", "ARCHIVO NO VALIDO", "ERROR AL GENERAR", "MANIFESTACIÓN TRANSMITIDA"];
            if (estatus in arr_estatus) return arr_estatus[estatus];
            else return estatus;
        },


        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = "";
            this.model.fecha_de = "";
            this.model.fecha_a = "";
            this.model.archivo = "";
            this.listado = "";
        },



        eliminarReporte: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: idreporte,
                    };
                    axios
                        .post(this.$hostname + "bandeja_temporal/delete_bitacora_manifestacion/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar();
                        });
                }
            });
        },

        generarMV: function (registro) {
             let self = this;
            this.$swal({
                type: "info",
                title: "Confirme",
                text: "¿Realmente desea generar la Solicitud de la MVe?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: registro.id,
                    };
                    axios
                        .post(this.$hostname + "manifestacion/crear_manifestacion/", datos)
                        .then((res) => {
                            let id_agente = self.GetidSellos(registro.curp);
                            if(registro.eDocuments.length> 0 ){
                                self.model.archivos = registro.eDocuments;
                                self.model.nombre = registro.nombre_proceso;
                                self.model.id_manifestacion = res.data.id;
                                self.crearprocesoEdocs(id_agente);
                            }

                            if(registro.coves.length > 0 ){
                                self.model.archivos = registro.coves;
                                self.model.nombre = registro.nombre_proceso;
                                self.model.id_manifestacion = res.data.id;
                                self.crearprocesoCoves(id_agente);
                            }
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "La Manifestación fue creada correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al crear la Manifestación. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar();
                        });
                }
            });
        },

        remplazarMV: function (registro) {
             let self = this;
            this.$swal({
                type: "info",
                title: "Confirme",
                text: "¿Realmente desea reemplazar la Manifestación de Valor?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: registro.id,
                    };
                    axios
                        .post(this.$hostname + "manifestacion/actualiza_bitacora_manifestacion/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "La Manifestación fue reemplazada correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "La manifestación no puede ser remplazada, verifique que no este transmitida",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar();
                        });
                }
            });
        },



        generarMVMasivo: function (registro) {
            let self = this;
                    self.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: registro.id,
                    };
                    axios
                        .post(self.$hostname + "manifestacion/crear_manifestacion/", datos)
                        .then((res) => {
                           let id_agente = self.GetidSellos(registro.curp);
                            if(registro.eDocuments.length> 0 ){
                                self.model.archivos = registro.eDocuments;
                                self.model.nombre = registro.nombre_proceso;
                                self.model.id_manifestacion = res.data.id;
                                self.crearprocesoEdocs(id_agente);
                            }

                            if(registro.coves.length > 0 ){
                                self.model.archivos = registro.coves;
                                self.model.nombre = registro.nombre_proceso;
                                self.model.id_manifestacion = res.data.id;
                                self.crearprocesoCoves(id_agente);
                            }

                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .then(() => {
                        });

        },
        download_pdf: function (key_pdf) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key_pdf,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        download: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: this.model.rfc + "/archivosM/" + key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        crearprocesoCoves(id_agente) {
            let self = this;
            let archivos= [];
                    self.model.archivos.forEach(function(c){
                        archivos.push({'cove':c})
                    });

                    let data = {
                        "rfc": self.model.rfc,
                        "tipo_clave_ws": 0,
                        "id_certificado": 0,
                        "archivos": archivos,
                        "descripcion": self.model.nombre,
                        "id_manifestacion": self.model.id_manifestacion,
                        "id_usuario": self.model.usuario,
                        "id_cliente": self.$local_storage.get("id_cliente")

                    };

                   axios.post(self.$hostname + "vucem/solicitud_coves_agente/", data)
                        .then(res => {
                        })
                        .catch(err => {
                            console.log(err);
                        }).then(() => {
                        });
            if(id_agente > 0){
                       let data2 = {
                        "rfc": self.model.rfc,
                        "tipo_clave_ws": 1,
                        "id_certificado": id_agente,
                        "archivos": archivos,
                        "descripcion": self.model.nombre,
                        "id_manifestacion": self.model.id_manifestacion,
                        "id_usuario": self.model.usuario,
                        "id_cliente": self.$local_storage.get("id_cliente")

                    };

                   axios.post(self.$hostname + "vucem/solicitud_coves_agente/", data2)
                        .then(res => {
                        })
                        .catch(err => {
                            console.log(err);
                        }).then(() => {
                        });

            }


        },

        crearprocesoEdocs(id_agente) {
            let self = this;
             let archivos= [];
                    self.model.archivos.forEach(function(c){
                        archivos.push({'edocument':c})
                    });
                    let data = {
                        "rfc": self.model.rfc,
                        "tipo_clave_ws": 0,
                        "id_certificado": 0,
                        "archivos": archivos,
                        "descripcion": self.model.nombre,
                        "id_manifestacion": self.model.id_manifestacion,
                        "id_usuario": self.model.usuario,
                        "id_cliente": self.$local_storage.get("id_cliente")

                    };

                   axios.post(self.$hostname + "vucem/solicitud_edocs_agente/", data)
                        .then(res => {
                        })
                        .catch(err => {
                            console.log(err);
                        }).then(() => {
                        });

                if(id_agente> 0){
                        let data2 = {
                            "rfc": self.model.rfc,
                            "tipo_clave_ws": 1,
                            "id_certificado": id_agente,
                            "archivos": archivos,
                            "descripcion": self.model.nombre,
                            "id_manifestacion": self.model.id_manifestacion,
                            "id_usuario": self.model.usuario,
                            "id_cliente": self.$local_storage.get("id_cliente")

                        };

                        axios.post(self.$hostname + "vucem/solicitud_edocs_agente/", data2)
                                .then(res => {
                                })
                                .catch(err => {
                                    console.log(err);
                                }).then(() => {
                                });
                }

        },

        GetidSellos(curp){

            var patentes = this.patentes;

                const ix =  patentes.findIndex(c => c.curp===curp );


                if(ix>=0)
                    return patentes[ix].id;
                else
                    return 0;

        },

    },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #eeeeee;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

</style>
